/* ============================================================
   Produtos Relacionados + "Leve junto" by🔥Pista — v2 2026-07-16
   ------------------------------------------------------------
   Par do snippets/related-products-pista.liquid (bloco
   related_products_pista do main-product).

   MODOS DE CONTEÚDO:
   • data-static="true"  → cards já renderizados server-side a partir
     do metafield do Search & Discovery (inclui itens por encomenda).
     Nenhum fetch é feito.
   • data-static="false" → fallback: busca a API de recomendações
     (?intent=...) e injeta o innerHTML, como na v1. Obs.: a API da
     Shopify FILTRA produtos com estoque 0 no intent=complementary.

   "LEVE JUNTO" (data-upsell="true"):
   • Cada card tem um seletor (canto direito). Ao clicar no botão
     principal de adicionar/encomendar com itens selecionados, um
     modal confirma variação + quantidade de cada item (quantidade
     pré-preenchida com a quantidade do produto principal).
   • Produtos com variante única são auto-selecionados (só confirma
     quantidade). Opções com um único valor também são pré-marcadas.
   • Confirmar → POST /cart/add.js com os itens relacionados e, em
     seguida, re-dispara o clique original (flag de bypass) para o
     fluxo AJAX normal do tema adicionar o produto principal e abrir
     o side cart com tudo.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Custom element (conteúdo) ---------- */
  if (!customElements.get('related-products-pista')) {
    class RelatedProductsPista extends HTMLElement {
      connectedCallback() {
        if (this.dataset.static === 'true') return; // server-side via metafield
        if (this.dataset.rpLoaded === 'true') return;

        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver(
            (entries) => {
              if (entries.some((entry) => entry.isIntersecting)) {
                observer.disconnect();
                this.loadRecommendations();
              }
            },
            { rootMargin: '400px 0px' }
          );
          observer.observe(this);
        } else {
          this.loadRecommendations();
        }
      }

      async loadRecommendations() {
        if (this.dataset.rpLoaded === 'true') return;
        this.dataset.rpLoaded = 'true';

        const url = this.dataset.url;
        if (!url) return;

        try {
          const response = await fetch(url);
          if (!response.ok) return;

          let text = await response.text();
          // Neutraliza custom elements pesados do render completo da
          // seção (mesma lista do build-complementary-products.js).
          text = text
            .replaceAll('variant-selects', 'div')
            .replaceAll('variant-radios', 'div')
            .replaceAll('product-tab', 'div')
            .replaceAll('compare-color', 'div')
            .replaceAll('breadcrumb-component', 'div');

          const holder = document.createElement('div');
          holder.innerHTML = text;

          const content = holder.querySelector('[data-related-products-pista]');

          if (content && content.innerHTML.trim().length) {
            this.innerHTML = content.innerHTML;
            this.classList.add('is-loaded');

            if (
              window.sharedFunctions &&
              typeof window.sharedFunctions.checkNeedToConvertCurrency === 'function' &&
              window.sharedFunctions.checkNeedToConvertCurrency() &&
              typeof Currency !== 'undefined' &&
              window.jQuery
            ) {
              Currency.convertAll(
                window.shop_currency,
                window.jQuery('#currencies .active').attr('data-currency'),
                'span.money',
                'money_format'
              );
            }
          } else {
            const wrapper = this.closest('.productView-moreItem');
            if (wrapper) wrapper.style.display = 'none';
          }
        } catch (error) {
          console.warn('[related-products-pista] Falha ao buscar recomendações:', error);
        }
      }
    }
    customElements.define('related-products-pista', RelatedProductsPista);
  }

  /* ---------- "Leve junto" ---------- */
  if (window.__pistaLeveJuntoInit) return;
  window.__pistaLeveJuntoInit = true;

  let bypass = false; // deixa o clique programático passar após o modal
  let pendingButton = null; // botão original clicado, re-disparado após confirmar

  const money = (cents) =>
    (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

  const getModal = () => document.querySelector('[data-rp-modal]');

  const getSelectedCards = () =>
    Array.from(
      document.querySelectorAll('related-products-pista[data-upsell="true"] [data-rp-card].is-selected')
    );

  const getMainQty = () => {
    const input = document.querySelector('form[data-type="add-to-cart-form"] input[name="quantity"], .productView input[name="quantity"]');
    const value = input ? parseInt(input.value, 10) : 1;
    return Number.isFinite(value) && value > 0 ? value : 1;
  };

  const cardData = (card) => {
    const script = card.querySelector('[data-rp-json]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      console.warn('[related-products-pista] JSON inválido no card:', error);
      return null;
    }
  };

  /* --- Seleção no card (toggle) --- */
  document.addEventListener('click', (event) => {
    const check = event.target.closest('[data-rp-check]');
    if (!check) return;
    event.preventDefault();
    event.stopPropagation();
    const card = check.closest('[data-rp-card]');
    if (!card) return;
    const selected = card.classList.toggle('is-selected');
    check.setAttribute('aria-pressed', selected ? 'true' : 'false');
  });

  /* --- Interceptação do botão principal (Adicionar/Encomenda) --- */
  document.addEventListener(
    'click',
    (event) => {
      if (bypass) return;

      const button = event.target.closest('[data-btn-addToCart]');
      if (!button) return;
      // Só o form principal do produto (ignora quick view etc.)
      if (!button.closest('form[data-type="add-to-cart-form"]')) return;

      const selectedCards = getSelectedCards();
      if (!selectedCards.length) return;

      const modal = getModal();
      if (!modal) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      pendingButton = button;
      openModal(modal, selectedCards);
    },
    true // capture: age antes dos handlers AJAX do tema
  );

  /* --- Modal --- */
  function openModal(modal, cards) {
    // O wrapper do bloco tem animação com transform, o que quebra
    // position:fixed (header cobria o modal e o backdrop sumia).
    // Movendo para o <body>, overlay/z-index/centralização funcionam.
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    const body = modal.querySelector('[data-rp-modal-body]');
    const errorBox = modal.querySelector('[data-rp-modal-error]');
    errorBox.hidden = true;
    errorBox.textContent = '';
    body.innerHTML = '';

    const mainQty = getMainQty();

    cards.forEach((card) => {
      const data = cardData(card);
      if (!data) return;
      body.appendChild(buildRow(data, mainQty));
    });

    modal.hidden = false;
    document.documentElement.classList.add('rp-upsell-open');
    updateConfirmState(modal);
  }

  function closeModal() {
    const modal = getModal();
    if (!modal) return;
    modal.hidden = true;
    document.documentElement.classList.remove('rp-upsell-open');
  }

  function buildRow(data, mainQty) {
    const row = document.createElement('div');
    row.className = 'rp-upsell-row';
    row.dataset.rpRow = '';
    row.__rpData = data;

    const singleVariant = data.has_only_default || data.variants.length === 1;

    row.innerHTML = `
      <div class="rp-upsell-row-media">${data.image ? `<img src="${data.image}" alt="">` : ''}</div>
      <div class="rp-upsell-row-info">
        <span class="rp-upsell-row-name">${escapeHtml(data.title)}</span>
        ${data.encomenda ? `<span class="rp-upsell-row-encomenda">Por encomenda: ${escapeHtml(data.encomenda)}</span>` : ''}
        <div class="rp-upsell-row-options"></div>
        <div class="rp-upsell-row-bottom">
          <div class="rp-upsell-qty">
            <button type="button" class="rp-upsell-qty-btn" data-rp-qty-minus aria-label="Diminuir quantidade">&minus;</button>
            <input type="text" class="rp-upsell-qty-input" data-rp-qty value="${mainQty}" inputmode="numeric" autocomplete="off">
            <button type="button" class="rp-upsell-qty-btn" data-rp-qty-plus aria-label="Aumentar quantidade">+</button>
          </div>
          <div class="rp-upsell-row-prices">
            <span class="rp-upsell-price-pix" data-rp-price-pix></span>
            <span class="rp-upsell-price-full" data-rp-price-full></span>
            <span class="rp-upsell-price-parc" data-rp-price-parc></span>
          </div>
        </div>
      </div>
    `;

    const optionsWrap = row.querySelector('.rp-upsell-row-options');

    if (singleVariant) {
      row.__rpVariant = data.variants[0];
    } else {
      data.options.forEach((option, index) => {
        const label = document.createElement('label');
        label.className = 'rp-upsell-option';
        const single = option.values.length === 1;
        label.innerHTML = `
          <span>${escapeHtml(option.name)}</span>
          <select data-rp-option data-rp-option-index="${index}">
            ${single ? '' : '<option value="">Selecione</option>'}
            ${option.values
              .map((value) => `<option value="${escapeHtml(value)}"${single ? ' selected' : ''}>${escapeHtml(value)}</option>`)
              .join('')}
          </select>
        `;
        optionsWrap.appendChild(label);
      });
      refreshOptionAvailability(row); // desabilita valores esgotados já na abertura
      resolveRowVariant(row); // auto-resolve quando todas as opções têm valor único
      updateEmptyState(row);
    }

    updateRowPrice(row);
    return row;
  }

  function resolveRowVariant(row) {
    const data = row.__rpData;
    if (!data) return;

    if (data.has_only_default || data.variants.length === 1) {
      row.__rpVariant = data.variants[0];
      return;
    }

    const selects = Array.from(row.querySelectorAll('[data-rp-option]'));
    const chosen = selects.map((select) => select.value);
    if (chosen.some((value) => !value)) {
      row.__rpVariant = null;
      return;
    }
    row.__rpVariant =
      data.variants.find((variant) => variant.options.every((opt, i) => opt === chosen[i])) || null;
  }

  function modalConfig() {
    const modal = getModal();
    const d = modal ? modal.dataset : {};
    return {
      pixOn: d.pixOn === 'true',
      pixPct: d.pixPct || '',
      parcelas: parseInt(d.parcelas, 10) || 1,
      limitador: d.limitador === 'true',
      limitadorValor: parseFloat(d.limitadorValor) || 0,
    };
  }

  // Mesma lógica de snippets/parcelamento.liquid (sobre o total cheio)
  function installments(totalCents, cfg) {
    let max = cfg.parcelas;
    if (cfg.limitador && cfg.limitadorValor > 0) {
      const possible = Math.floor(totalCents / (cfg.limitadorValor * 100));
      if (possible < max) max = possible;
    }
    if (max < 1) max = 1;
    return { max, value: Math.floor(totalCents / max) };
  }

  // Existe variante COMPRÁVEL com value na posição optionIndex,
  // respeitando as demais opções já escolhidas?
  function hasAvailableVariant(data, optionIndex, value, chosen) {
    return data.variants.some(
      (variant) =>
        variant.available !== false &&
        variant.options[optionIndex] === value &&
        chosen.every((choice, j) => j === optionIndex || !choice || variant.options[j] === choice)
    );
  }

  // Desabilita opções sem estoque (como um variant picker de verdade):
  // valor sem nenhuma variante comprável ganha "(esgotado)" e disabled.
  // Combinação que deixou de existir reseta o select para "Selecione".
  function refreshOptionAvailability(row) {
    const data = row.__rpData;
    const selects = Array.from(row.querySelectorAll('[data-rp-option]'));
    if (!data || !selects.length) return;

    for (let pass = 0; pass < 2; pass++) {
      const chosen = selects.map((select) => select.value);
      selects.forEach((select, i) => {
        Array.from(select.options).forEach((optionEl) => {
          if (!optionEl.value) return; // placeholder "Selecione"
          if (!optionEl.dataset.baseLabel) optionEl.dataset.baseLabel = optionEl.textContent;
          const ok = hasAvailableVariant(data, i, optionEl.value, chosen);
          optionEl.disabled = !ok;
          optionEl.textContent = ok
            ? optionEl.dataset.baseLabel
            : optionEl.dataset.baseLabel + ' (esgotado)';
        });
        // Valor atual ficou impossível/esgotado → volta ao placeholder
        const current = select.selectedOptions[0];
        if (current && current.value && current.disabled) {
          select.value = '';
        }
      });
    }
  }

  // Borda vermelha nos selects ainda não preenchidos
  function updateEmptyState(row) {
    row.querySelectorAll('[data-rp-option]').forEach((select) => {
      select.classList.toggle('is-empty', !select.value);
    });
  }

  function updateRowPrice(row) {
    const pixEl = row.querySelector('[data-rp-price-pix]');
    const fullEl = row.querySelector('[data-rp-price-full]');
    const parcEl = row.querySelector('[data-rp-price-parc]');
    const qtyInput = row.querySelector('[data-rp-qty]');
    const qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
    const variant = row.__rpVariant;

    if (!variant) {
      pixEl.innerHTML = '';
      fullEl.textContent = '';
      parcEl.innerHTML = '';
      return;
    }

    if (variant.available === false) {
      pixEl.innerHTML = '<span class="rp-upsell-soldout">Esgotado</span>';
      fullEl.textContent = '';
      parcEl.innerHTML = '';
      return;
    }

    const cfg = modalConfig();
    const fullTotal = variant.price_cents * qty;
    const parc = installments(fullTotal, cfg);

    if (cfg.pixOn) {
      const pixTotal = variant.display_cents * qty;
      pixEl.innerHTML = `${money(pixTotal)}<span class="rp-pix-tag">no Pix${cfg.pixPct ? ' -' + escapeHtml(cfg.pixPct) + '%' : ''}</span>`;
      fullEl.textContent = `ou ${money(fullTotal)}`;
    } else {
      pixEl.textContent = money(fullTotal);
      fullEl.textContent = '';
    }

    parcEl.innerHTML = parc.max > 1
      ? `em até ${parc.max}x de <b>${money(parc.value)}</b> sem juros`
      : '';
  }

  function updateConfirmState(modal) {
    const rows = Array.from(modal.querySelectorAll('[data-rp-row]'));
    const confirmButton = modal.querySelector('[data-rp-modal-confirm]');
    const ready =
      rows.length > 0 &&
      rows.every((row) => row.__rpVariant && row.__rpVariant.available !== false);
    confirmButton.disabled = !ready;
  }

  /* --- Eventos internos do modal (delegação) --- */
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-rp-option]');
    if (select) {
      const row = select.closest('[data-rp-row]');
      refreshOptionAvailability(row);
      resolveRowVariant(row);
      updateEmptyState(row);
      updateRowPrice(row);
      updateConfirmState(getModal());
      return;
    }
    const qty = event.target.closest('[data-rp-qty]');
    if (qty) {
      if (parseInt(qty.value, 10) < 1 || !qty.value) qty.value = 1;
      updateRowPrice(qty.closest('[data-rp-row]'));
    }
  });

  document.addEventListener('input', (event) => {
    const qty = event.target.closest('[data-rp-qty]');
    if (!qty) return;
    const clean = qty.value.replace(/\D/g, '');
    if (clean !== qty.value) qty.value = clean;
    if (qty.value) updateRowPrice(qty.closest('[data-rp-row]'));
  });

  document.addEventListener('click', async (event) => {
    const modal = event.target.closest('[data-rp-modal]');
    if (!modal) return;

    if (event.target.closest('[data-rp-modal-close]')) {
      closeModal();
      return;
    }

    const minus = event.target.closest('[data-rp-qty-minus]');
    const plus = event.target.closest('[data-rp-qty-plus]');
    if (minus || plus) {
      const row = event.target.closest('[data-rp-row]');
      const input = row.querySelector('[data-rp-qty]');
      const current = Math.max(1, parseInt(input.value, 10) || 1);
      input.value = plus ? current + 1 : Math.max(1, current - 1);
      updateRowPrice(row);
      return;
    }

    if (event.target.closest('[data-rp-modal-skip]')) {
      // Adiciona só o principal: limpa seleções e re-dispara o clique.
      clearSelections();
      closeModal();
      triggerPendingButton();
      return;
    }

    if (event.target.closest('[data-rp-modal-confirm]')) {
      await confirmAndAdd(modal);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      const modal = getModal();
      if (modal && !modal.hidden) closeModal();
    }
  });

  function clearSelections() {
    getSelectedCards().forEach((card) => {
      card.classList.remove('is-selected');
      const check = card.querySelector('[data-rp-check]');
      if (check) check.setAttribute('aria-pressed', 'false');
    });
  }

  function triggerPendingButton() {
    if (!pendingButton) return;
    const button = pendingButton;
    pendingButton = null;
    bypass = true;
    button.click();
    bypass = false;
  }

  async function confirmAndAdd(modal) {
    const rows = Array.from(modal.querySelectorAll('[data-rp-row]'));
    const errorBox = modal.querySelector('[data-rp-modal-error]');
    const confirmButton = modal.querySelector('[data-rp-modal-confirm]');

    const items = rows
      .filter((row) => row.__rpVariant && row.__rpVariant.available !== false)
      .map((row) => ({
        id: row.__rpVariant.id,
        quantity: Math.max(1, parseInt(row.querySelector('[data-rp-qty]').value, 10) || 1),
      }));

    if (!items.length) return;

    confirmButton.disabled = true;
    confirmButton.classList.add('is-loading');
    errorBox.hidden = true;

    try {
      const response = await fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });

      if (!response.ok) {
        const payload = await response.json().catch(() => ({}));
        throw new Error(payload.description || payload.message || 'Não foi possível adicionar os itens selecionados.');
      }

      // Sucesso: fecha, limpa seleções e segue o fluxo normal do tema
      // para o produto principal (abre o side cart com tudo).
      clearSelections();
      closeModal();
      triggerPendingButton();
    } catch (error) {
      errorBox.textContent = error.message;
      errorBox.hidden = false;
    } finally {
      confirmButton.disabled = false;
      confirmButton.classList.remove('is-loading');
    }
  }

  function escapeHtml(text) {
    return String(text == null ? '' : text)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }
})();
